import { USE_BLS_THEME } from '@constants';
import { Box, Stack, SxProps, Theme, Typography, useMediaQuery } from '@mui/material';
import useTheme from '~/theme/ThemeProvider';

interface HeaderProps {
  sx?: SxProps<Theme>;
}

export default function Header({ sx }: HeaderProps) {
  const appTheme = useTheme();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'));

  if (USE_BLS_THEME) {
    return isMobile ? (
      <Box
        sx={{
          height: { xs: 35, sm: 50 },
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          ...sx,
        }}
      >
        <img src="/logos/bls_wordmark.svg" alt="Bikeleasing Wordmark" draggable="false" />
      </Box>
    ) : (
      <Box sx={{ ...sx }}>
        <img src="/logos/bls_fahne.svg" alt="Bikeleasing Fahne" draggable="false" />
      </Box>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={{ xs: 1.5, md: 2.5 }}
      sx={{ justifyContent: 'flex-start', width: '100%', minWidth: 0, ...sx, alignItems: 'center' }}
    >
      <Box
        component="img"
        src="/logos/probonio_wordmark.svg"
        alt="Probonio"
        draggable="false"
        // The height acts as a cap rather than a fixed size: on a narrow viewport the
        // logos shrink (keeping their aspect ratio) instead of pushing the row past the
        // screen edge and forcing a horizontal scroll.
        sx={{
          maxHeight: { xs: 32, md: 44 },
          width: 'auto',
          height: 'auto',
          maxWidth: '100%',
          minWidth: 0,
          flexShrink: 1,
          objectFit: 'contain',
        }}
      />
      <Typography
        component="span"
        aria-hidden
        sx={{ color: appTheme.colors.PRIMARY_DARK, fontSize: { xs: 16, md: 24 }, lineHeight: 1, flexShrink: 0 }}
      >
        ✕
      </Typography>
      <Box
        component="img"
        src="/logos/bls_wordmark.svg"
        alt="Bikeleasing Wordmark"
        draggable="false"
        sx={{
          maxHeight: { xs: 25, md: 34 },
          width: 'auto',
          height: 'auto',
          maxWidth: '100%',
          minWidth: 0,
          flexShrink: 1,
          objectFit: 'contain',
        }}
      />
    </Stack>
  );
}
